"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _core = require("@material-ui/core");

var _CardContainer = _interopRequireDefault(require("vf-comps/build/components/organisms/cards/cardContainer/CardContainer"));

var _CardAction = _interopRequireDefault(require("vf-comps/build/components/organisms/cards/cardContainer/CardAction"));

var _GridItem = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridItem"));

var _GridContainer = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridContainer"));

var _SystemIcon = _interopRequireDefault(require("vf-comps/build/components/protons/icons/SystemIcon"));

var _Typography = _interopRequireDefault(require("vf-comps/build/components/protons/typography/Typography"));

var _BoxFlex = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxFlex/BoxFlex.js"));

var _BoxSizing = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxSizing/BoxSizing"));

var _MidRendererIcon = _interopRequireDefault(require("vf-comps/build/components/protons/icons/MidRendererIcon"));

var _BoxVisibility = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxVisibility/BoxVisibility"));

var _BoxStyled = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxStyled/BoxStyled"));

var _useTranslation = _interopRequireDefault(require("../customHooks/useTranslation"));

var _config = _interopRequireDefault(require("../config"));

var _appConstants = require("../constants/appConstants");

var _analyticsActions = require("../actions/analyticsActions");

var _appActions = require("../actions/appActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MenuActions = function MenuActions(_ref) {
  var __instanceId = _ref.__instanceId,
      customerSearchComponent = _ref.customerSearchComponent;
  var dispatch = (0, _reactRedux.useDispatch)();
  var t = (0, _useTranslation.default)();
  var theme = (0, _core.useTheme)();
  var history = (0, _reactRouterDom.useHistory)();
  var isSmall = (0, _core.useMediaQuery)(theme.breakpoints.down("xs"));
  var isDesktop = (0, _core.useMediaQuery)(theme.breakpoints.up("md"));
  var isLarge = (0, _core.useMediaQuery)("(min-width:1380px)");

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.config.data && state.config.data.widgets[_appConstants.pkgName][__instanceId] ? state.config.data.widgets[_appConstants.pkgName][__instanceId] : _config.default;
  }),
      actionItems = _useSelector.actionItems,
      title = _useSelector.title;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state[customerSearchComponent] || {};
  }),
      type = _useSelector2.type,
      selectedBillingAccount = _useSelector2.selectedBillingAccount;

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    return state[_appConstants.pkgName];
  }),
      impersonationToken = _useSelector3.impersonationToken;

  var getMappedCustomerInfo = function getMappedCustomerInfo() {
    var _selectedBillingAccou, _selectedBillingAccou2, _selectedBillingAccou3, _selectedBillingAccou4;

    var value;
    var customerType;
    var typeValue = selectedBillingAccount === null || selectedBillingAccount === void 0 ? void 0 : (_selectedBillingAccou = selectedBillingAccount.party) === null || _selectedBillingAccou === void 0 ? void 0 : (_selectedBillingAccou2 = _selectedBillingAccou.individualIdentification[0]) === null || _selectedBillingAccou2 === void 0 ? void 0 : _selectedBillingAccou2.identificationId;
    var emailAddress = selectedBillingAccount === null || selectedBillingAccount === void 0 ? void 0 : (_selectedBillingAccou3 = selectedBillingAccount.party) === null || _selectedBillingAccou3 === void 0 ? void 0 : (_selectedBillingAccou4 = _selectedBillingAccou3.contactMedium) === null || _selectedBillingAccou4 === void 0 ? void 0 : _selectedBillingAccou4.find(function (el) {
      return el.mediumType === "Email";
    }).characteristic.emailAddress;

    if ((typeValue === null || typeValue === void 0 ? void 0 : typeValue.indexOf("-")) > 0) {
      var _typeValue$split = typeValue.split("-");

      var _typeValue$split2 = _slicedToArray(_typeValue$split, 2);

      customerType = _typeValue$split2[0];
      value = _typeValue$split2[1];
    } else {
      value = typeValue;
    }

    return {
      "PROFILE TYPE": "Consumer",
      "LOGIN TYPE": customerType || type,
      "LOGIN VALUE": value,
      GROUP: "Administrator",
      "CLIENT TYPE": "Full",
      EMAIL: emailAddress,
      MSISDN: "664241394"
    };
  };

  (0, _react.useEffect)(function () {
    if (selectedBillingAccount && Object.keys(selectedBillingAccount).length) {
      dispatch((0, _appActions.getImpersonationToken)(getMappedCustomerInfo()));
    }
  }, []);

  var handleCardClick = function handleCardClick(eventName, actionRedirectionURL, ikkiRedirection, actions) {
    dispatch((0, _analyticsActions.sendTags)({
      taggingId: 'MENU_ACTIONS_1',
      taggingType: 'link',
      taggingValue: {}
    }));
    if (ikkiRedirection) history.push({
      pathname: actionRedirectionURL,
      search: "?jwe=".concat(impersonationToken)
    });

    if (actionRedirectionURL) {
      history.push(actionRedirectionURL, actionRedirectionURL);
    }

    if (actions && (actions === null || actions === void 0 ? void 0 : actions.length) >= 1) {
      actions.forEach(function (_ref2) {
        var actionType = _ref2.actionType,
            actionPayload = _ref2.actionPayload;
        dispatch({
          type: actionType,
          payload: actionPayload
        });
      });
    }
  };

  var renderActionTile = function renderActionTile(_ref3) {
    var actionIcon = _ref3.actionIcon,
        actionTranslationId = _ref3.actionTranslationId,
        actionRedirectionTextId = _ref3.actionRedirectionTextId,
        actionRedirectionURL = _ref3.actionRedirectionURL,
        ikkiRedirection = _ref3.ikkiRedirection,
        actions = _ref3.actions;
    return /*#__PURE__*/_react.default.createElement(_CardAction.default, {
      action: function action() {
        return handleCardClick(actionRedirectionTextId, actionRedirectionURL, ikkiRedirection, actions);
      },
      "data-testid": "".concat(actionTranslationId, "-Card")
    }, /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
      "data-testid": "action-card-".concat(actionTranslationId)
    }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, _defineProperty({
      pl: "xl",
      pb: "small",
      pt: "larger"
    }, "pt", "medium"), /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
      disableGutters: true
    }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      xs: 8,
      sm: 12,
      md: 9
    }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      xs: 12,
      sm: 9,
      md: 12
    }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
      pt: "medium",
      pb: "medium",
      maxWidth: "100%"
    }, /*#__PURE__*/_react.default.createElement(_BoxStyled.default, {
      className: {
        minHeight: "60px"
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "DarkGrey",
      light: true,
      text: "".concat(t(actionTranslationId)),
      variant: isSmall ? "h3" : "h5",
      "data-testid": "".concat(actionTranslationId, "-name")
    })))), /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
      mt: "small"
    }, /*#__PURE__*/_react.default.createElement(_BoxFlex.default, null, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
      mr: "small"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      color: "VfRed",
      regular: true,
      text: "".concat(t(actionRedirectionTextId)),
      variant: "bodySmall",
      "data-testid": "".concat(actionRedirectionTextId, "-text")
    })), /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      color: "red",
      icon: "ic_chevron__right",
      size: "medium"
    })))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      md: 2
    }, /*#__PURE__*/_react.default.createElement(_BoxVisibility.default, {
      xs: "block",
      sm: "none",
      md: "block"
    }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
      mt: "medium"
    }, /*#__PURE__*/_react.default.createElement(_MidRendererIcon.default, {
      icon: actionIcon,
      size: "large",
      "data-testid": "".concat(actionTranslationId, "-icon")
    }))))))));
  };

  return /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    justify: "flex-start",
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mb: "xxl",
    mt: "xxl",
    pb: isDesktop ? "medium" : isSmall ? "none" : "mini",
    pt: isSmall ? "xl" : "xxl"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "DarkGrey",
    regular: true,
    bold: true,
    text: "".concat(t(title)),
    variant: "h4",
    align: "left",
    "data-testid": "main-actions-title"
  }))), /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, actionItems.map(function (actionItem) {
    return /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      xs: 12,
      sm: 6,
      md: 6,
      key: actionItem.actionTranslationId
    }, renderActionTile(actionItem));
  }))));
};

var _default = MenuActions;
exports.default = _default;